module.exports = __webpack_public_path__ + "images/2abc4baa.png";